import { render, staticRenderFns } from "./LearnContentSlug.vue?vue&type=template&id=08f10600&scoped=true&"
import script from "./LearnContentSlug.vue?vue&type=script&lang=ts&"
export * from "./LearnContentSlug.vue?vue&type=script&lang=ts&"
import style0 from "./LearnContentSlug.vue?vue&type=style&index=0&id=08f10600&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f10600",
  null
  
)

export default component.exports